import { useGlobalStore } from '@highlight/ipc/react'
import { useMemo } from 'react'

export const usePushToTalkPermission = () => {
  const [isPushToTalkEnabled, setIsPushToTalkEnabled] = useGlobalStore<boolean>(
    'settings',
    'push-to-talk-enabled',
    false,
  )

  return useMemo(() => {
    return {
      isPushToTalkEnabled,
      setIsPushToTalkEnabled,
    }
  }, [isPushToTalkEnabled, setIsPushToTalkEnabled])
}
